<template>
  <transition name="fade">
    <div v-if="visible" class="notification-toast">
      <span>{{ notification.message }}</span>
      <button @click="close">×</button>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { EventBus } from '../../services/eventBus.js'

const visible = ref(false)
const notification = ref<any>({})
let timeout: any = null

function showToast(n: any) {
  notification.value = n
  visible.value = true
  clearTimeout(timeout)
  timeout = setTimeout(() => (visible.value = false), 4000)
}
function close() {
  visible.value = false
  clearTimeout(timeout)
}
onMounted(() => {
  EventBus.on('notification', showToast)
})
onUnmounted(() => {
  EventBus.off('notification', showToast)
  clearTimeout(timeout)
})
</script>

<style scoped>
.notification-toast {
  position: fixed;
  bottom: 2em;
  right: 2em;
  background: #323232;
  color: #fff;
  padding: 1em 2em;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100000; /* Raised so toast appears above modal/overlay components */
  display: flex;
  align-items: center;
  gap: 1em;
}
.notification-toast button {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.2em;
  cursor: pointer;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
